
export function createXLSheetdata(attritionList) {
    attritionList.find((ticketDetails, index) => {                


                delete attritionList[index]['id']
                delete attritionList[index]['employee_id']

                attritionList[index].EmployeeCode=attritionList[index].employee_code
                delete attritionList[index]['employee_code']


                attritionList[index].EmployeeName=attritionList[index].employee_name                
                delete attritionList[index]['employee_name']

                attritionList[index].Department=attritionList[index].employee_department_name
                delete attritionList[index]['employee_department_name']

                attritionList[index].Designation=attritionList[index].employee_designation_name
                delete attritionList[index]['employee_designation_name']

                attritionList[index].WorkLocation=attritionList[index].work_location
                delete attritionList[index]['work_location']

                attritionList[index].WorkLocationId=attritionList[index].work_location_code
                delete attritionList[index]['work_location_code']



                attritionList[index].City=attritionList[index].employee_city_name
                delete attritionList[index]['employee_city_name']

                attritionList[index].ManagerReason=attritionList[index].manager_reason_name
                delete attritionList[index]['manager_reason_name']

                attritionList[index].ManagerRemarks=attritionList[index].manager_remarks
                delete attritionList[index]['manager_remarks']


                attritionList[index].AttritionStatus=attritionList[index].status
                delete attritionList[index]['status']

                attritionList[index].HrReason=attritionList[index].hr_reason_name
                delete attritionList[index]['hr_reason_name']

                attritionList[index].HrRemarks=attritionList[index].hr_remarks
                delete attritionList[index]['hr_remarks']

                attritionList[index].CreatedAt=attritionList[index].created
                delete attritionList[index]['created']

                attritionList[index].ModifiedAt=attritionList[index].modified
                delete attritionList[index]['modified']

                attritionList[index].LastWorkingDay=attritionList[index].last_working_day
                delete attritionList[index]['last_working_day']


                attritionList[index].InitiatedBy=attritionList[index].created_by
                delete attritionList[index]['created_by']

                attritionList[index].VerifiedBy=attritionList[index].modified_by
                delete attritionList[index]['modified_by']

                delete attritionList[index]['hr_reason_id']

                
            
                return false
            })   
            return attritionList
}



// WEBPACK FOOTER //
// ./src/modules/Employees/services/helpers.js